/*
Monotype Foundry Platform API
Version 1.0.0

Definition: InventoryIngestionRequest

Properties:
  type: string (required)
  projectName: string (required), minLength: 3, maxLength: 100
  mId: string
  foundryId: string (required)
*/

var InventoryIngestionRequest = (function () {
  function validateInventoryIngestionRequest (arg) {
    // Validate type
    if (!arg.type) {
      throw new Error('InventoryIngestionRequest.type: Missing property')
    }
    if (arg.type && !(typeof arg.type === 'string')) {
      throw new Error('InventoryIngestionRequest.type: Wrong type: Got \'' + (typeof arg.type) + '\', but expected: \'string\'')
    }
    // Validate projectName
    if (!arg.projectName) {
      throw new Error('InventoryIngestionRequest.projectName: Missing property')
    }
    if (arg.projectName && !(typeof arg.projectName === 'string')) {
      throw new Error('InventoryIngestionRequest.projectName: Wrong type: Got \'' + (typeof arg.projectName) + '\', but expected: \'string\'')
    }
    if (arg.projectName && !(arg.projectName.length >= 3)) {
      throw new Error('InventoryIngestionRequest.projectName: Minimum length 3, but got: ' + arg.projectName.length)
    }
    if (arg.projectName && !(arg.projectName.length <= 100)) {
      throw new Error('InventoryIngestionRequest.projectName: Maximum length 100, but got: ' + arg.projectName.length)
    }
    // Validate mId
    if (arg.mId && !(typeof arg.mId === 'string')) {
      throw new Error('InventoryIngestionRequest.mId: Wrong type: Got \'' + (typeof arg.mId) + '\', but expected: \'string\'')
    }
    // Validate foundryId
    if (!arg.foundryId) {
      throw new Error('InventoryIngestionRequest.foundryId: Missing property')
    }
    if (arg.foundryId && !(typeof arg.foundryId === 'string')) {
      throw new Error('InventoryIngestionRequest.foundryId: Wrong type: Got \'' + (typeof arg.foundryId) + '\', but expected: \'string\'')
    }
  }
  function buildInventoryIngestionRequest (arg) {
    var InventoryIngestionRequest = arg
    // Complete type
    // Expected Type: string
    InventoryIngestionRequest.type = InventoryIngestionRequest.type || ''
    // Complete projectName
    // Expected Type: string
    InventoryIngestionRequest.projectName = InventoryIngestionRequest.projectName || ''
    // Complete mId
    // Expected Type: string
    InventoryIngestionRequest.mId = InventoryIngestionRequest.mId || ''
    // Complete foundryId
    // Expected Type: string
    InventoryIngestionRequest.foundryId = InventoryIngestionRequest.foundryId || ''
    return InventoryIngestionRequest
  }
  return {
    validate: validateInventoryIngestionRequest,
    build: buildInventoryIngestionRequest
  }
})()

module.exports = InventoryIngestionRequest
